/* eslint-disable react/no-array-index-key */
import { FC } from "react";
import { useLocation } from "react-router-dom";

import Section from "web/Pages/Checkout/TourismDomestic/SharedComponents/Section";

import __ from "web/Layout/Translations";

import Accordion from "web/Components/Common/Accordion";
import type { AccordionVariant } from "web/Components/Common/Accordion/accordion";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import isGds from "web/utils/page/product/domesticTourism/isGds";

import tourismDefinition from "web/constants/tourismDefinition";
import urls from "web/constants/urls";

import { ICnsx } from "web/types/Tourism";

import CancellationPolicyOption from "./CancellationPolicyOption/cancellationPolicyOption";
import classes from "./cancellationPolicy.scss";
import useFreeCancellationInfo from "./utils/useFreeCancellationInfo";

interface ICheckoutTourismDomesticCancellationPolicyProps {
  type: string;
  options: ICnsx[];
  variant: AccordionVariant;
  createdAt?: Date;
  source?: string;
}

const CheckoutTourismDomesticCancellationPolicy: FC<
  ICheckoutTourismDomesticCancellationPolicyProps
> = ({ type, options, variant = "primary", createdAt, source }) => {
  const location = useLocation();
  const isOrderSummary = location.pathname.includes(urls.customerOrders);
  const isRefundable = type === "Refundable" || type === "FeeApplies";
  const isUnknown = type === "Unknown" || type === "Free";
  const message = !type.length
    ? tourismDefinition.cancellationPolicyMessages.NonRefundable
    : tourismDefinition.cancellationPolicyMessages[
        type as keyof typeof tourismDefinition.cancellationPolicyMessages
      ];

  const freeCancellationInfo = useFreeCancellationInfo(
    options[0]?.from,
    options[0]?.from_time,
    createdAt
  );

  return (
    <Section>
      <Accordion
        label={__("Anulacja i zmiana terminu rezerwacji")}
        variant={variant}
        arrow
        className={variant === "tertiary" ? null : classes.accordionRoot}
        expanded
      >
        <p className={classes.content}>
          {isUnknown ? (
            <p> {__(message as string)}</p>
          ) : (
            <ul className={classes.list}>
              {isArrayHasItems(message) ? (
                message.map((item) => (
                  <li className={classes.listItem} key={item}>
                    {__(item)}
                  </li>
                ))
              ) : (
                <>
                  {isRefundable &&
                    !isOrderSummary &&
                    source &&
                    isGds(source) && (
                      <li
                        className={classes.listItem}
                        key="refundableCancellationInfo"
                      >
                        {__(
                          tourismDefinition.cancellationPolicyMessages
                            .RefundableCancellationInfo
                        )}
                      </li>
                    )}
                  <li className={classes.listItem} key={message}>
                    {__(message)}
                    {isRefundable && (
                      <span key="options">
                        {options.map((option) => (
                          <CancellationPolicyOption
                            key={option.from}
                            option={option}
                            className={classes.content}
                          />
                        ))}
                        {freeCancellationInfo && (
                          <p className={classes.content}>
                            {freeCancellationInfo}
                          </p>
                        )}
                      </span>
                    )}
                  </li>
                </>
              )}
            </ul>
          )}
        </p>
        {isRefundable && (
          <ul className={classes.list}>
            {tourismDefinition.cancellationPolicyMessages.RefundableAdditional.map(
              (item) => (
                <li className={classes.listItem} key={item}>
                  {__(item)}
                </li>
              )
            )}
          </ul>
        )}
      </Accordion>
    </Section>
  );
};

export default CheckoutTourismDomesticCancellationPolicy;
